import React from "react";

import { AnimationDownloader } from "./AnimationDownloader";

export const useAnimationDownloader = (
  canvas: HTMLCanvasElement | null | undefined,
  audioSource: string,
) => {
  const downloader = React.useRef<AnimationDownloader>();
  const audio = React.useRef<HTMLAudioElement>();

  React.useEffect(() => {
    if (canvas) {
      audio.current = new Audio(audioSource);
      // We need to set this attribute or else browsers will
      // not attach the Origin header to our request. Anonymous
      // just means we don't need credentials to access file.
      audio.current.crossOrigin = "anonymous";
      downloader.current = new AnimationDownloader(canvas, audio.current);
    }
  }, [canvas, audioSource]);

  const startRecording = async () => {
    await downloader.current?.startRecording();
    await audio.current?.play();
  };

  const stopAndDownloadRecording = () => {
    downloader.current?.stopRecording();
  };

  const isRecording = () => downloader.current?.isRecording() ?? false;

  return { isRecording, startRecording, stopAndDownloadRecording };
};
